import { useMemo } from 'react'

import Box from '@mui/material/Box'
import MTable from '@mui/material/Table'

import useStyles from './styles'
import TableBody from './TableBody'
import TableHead from './TableHead'
import TableContentLoading from './TableContentLoading'

function extractOptions(options) {
  return {
    hover: options.hover || !!options.hoverClass,
    hoverClass: options.hover && (options.hoverClass || 'hover'),
    ...options
  }
}

export default function TableContent({title, options}) {
  const tableOptions = useMemo(() => extractOptions({...options}), [options])
  const classes = useStyles()

  return (
    <Box sx={{ overflow: 'auto', minHeight: 0 }}>
      <MTable className={classes.table} size={tableOptions.padding === 'dense' ? 'small' : 'medium'} aria-label={title} role="grid">
        <TableHead {...tableOptions} />
        <TableBody {...tableOptions} />
        <TableContentLoading/>
      </MTable>
    </Box>
  )
}
